
const components_hash = {}
const context = require.context('./', true, /\.js$/);
 context.keys().map((path) => {
    if (path === './index.js') {
        return 
    }
    const obj = context(path).default
    if (components_hash[obj.name]) {
        throw new Error('form组件的name必须唯一');  
    }
    components_hash[obj.name] = obj
})  

export default components_hash 

